
import * as defaultImport from "@splunk/react-icons/CheckBox";
export * from "@splunk/react-icons/CheckBox";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
